export default __webpack_public_path__ + "static/media/favicon.220111cb.ico";